import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Link2 } from 'react-feather';

import { Button } from '../../../ui';
import { errorText, getPortalLink, when } from '../../../TeacherHiring/hiringApi';

/**
 * Copies the candidate's personal page link, to send by hand (WhatsApp from
 * a phone, a call follow-up). The service makes one if they have none and
 * extends its expiry, so the copied link always opens.
 */
const CopyLinkButton: React.FC<{ candidateId: string; name: string; label?: boolean }> = ({ candidateId, name, label }) => {
  const [busy, setBusy] = useState(false);

  const copy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setBusy(true);
    try {
      const { url, expiresAt } = await getPortalLink(candidateId);
      try {
        await navigator.clipboard.writeText(url);
        toast.success(`${name}'s link copied · valid until ${when(expiresAt)}`);
      } catch {
        // Clipboard blocked (permissions, insecure origin): show it to copy by hand.
        toast.info(url, { autoClose: false, closeOnClick: false });
      }
    } catch (error) {
      toast.error(errorText(error));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      size="sm"
      variant={label ? 'secondary' : 'ghost'}
      icon={<Link2 size={14} />}
      loading={busy}
      onClick={copy}
      aria-label={`Copy ${name}'s candidate link`}
      title="Copy candidate link"
    >
      {label ? 'Copy candidate link' : undefined}
    </Button>
  );
};

export default CopyLinkButton;
